module.exports = __webpack_public_path__ + "img/logo1 (6).6841b24b.jpg";